export enum CreditCardsPageType {
  PaidRoundup = 'PaidRoundup',
  Roundup = 'Roundup',
  Review = 'Review',
  LandingPage = 'Landing Page',
}

export type MappedCreditCardsPageType = Exclude<
  CreditCardsPageType,
  CreditCardsPageType.LandingPage
>;

export enum TrafficOriginType {
  Organic = 'Organic',
  Paid = 'Paid',
}

export type TrafficOriginTypeProps = {
  trafficOriginType: TrafficOriginType;
};

export const CC_PAGE_TYPE: Record<TrafficOriginType, MappedCreditCardsPageType> = {
  [TrafficOriginType.Organic]: CreditCardsPageType.Roundup,
  [TrafficOriginType.Paid]: CreditCardsPageType.PaidRoundup,
};

export const CC_ROUNDUP_SEGMENT_PAGE_NAME: Record<TrafficOriginType, string> = {
  [TrafficOriginType.Organic]: 'cc_organic_roundup',
  [TrafficOriginType.Paid]: 'cc_paid_roundup',
};

export const CC_PAID_ROUNDUP_AO_PAGE_NAME = 'cc_paid_roundup_ao';

export const CC_PAGE_TYPE_TO_URL_PREFIX: Record<MappedCreditCardsPageType, string> = {
  [CreditCardsPageType.PaidRoundup]: '/credit-cards/m/best/',
  [CreditCardsPageType.Roundup]: '/credit-cards/best/',
  [CreditCardsPageType.Review]: '/credit-cards/reviews/',
};

export const CC_PREFIX_PATH: Record<TrafficOriginType, string> = {
  [TrafficOriginType.Organic]: '/credit-cards/best',
  [TrafficOriginType.Paid]: '/credit-cards/m/best',
};

export const CC_PRIMARY_CATEGORY_ID = '5';
export const CC_ATTRIBUTION_VERTICAL = 'Credit Cards';
